import React from "react";

import { makeStyles, Container, Typography } from "@material-ui/core";
import { EEventType, eventAnalytic } from "../../app/analytics";

const useStyles = makeStyles((theme) => ({
  root: {
    "marginBottom": theme.spacing(3),
    "& ol": { counterReset: "item", paddingLeft: "1em" },
    "& li": { display: "block" },
    "& li:before": {
      content: "counters(item, '.') ' '",
      counterIncrement: "item"
    },
    "& ol li": {
      fontSize: "1.25rem",
      fontWeight: "bold",
      marginBottom: theme.spacing(2)
    },
    "& ol li ol li": {
      "&:first-of-type": {
        marginTop: theme.spacing(1)
      },
      "fontSize": "1rem",
      "fontWeight": "normal",
      "marginBottom": theme.spacing(1)
    }
  }
}));

export const TermsPage: React.FC = () => {
  const classes = useStyles();
  eventAnalytic.useEffect(EEventType.PageTermsView);

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <h1>Terms &amp; Conditions</h1>
        <ol>
          <li>
            <span>Interpretation and Definitions</span>
            <ol>
              <li>
                Unless the contrary intention appears, words in the plural shall include the singular and words in the
                singular shall include the plural.
              </li>
              <li>
                Reference to any statute or provision of any statute shall be deemed to include any statutory
                modification, substitution or re-enactment thereof or any statutory instrument, order, regulation,
                bye-law, permission or direction made thereunder or under such modification, substitution or
                re-enactment.
              </li>
              <li>References to clauses are clauses in these Terms and Conditions.</li>
              <li>
                The term “person” shall include an individual, firm, company, corporation and any unincorporated bodies
                of persons.
              </li>
              <li>
                Wherever the following words and phrases appear in the Sales Quotation or these Terms and Conditions,
                they will have the following meaning:
                <ol>
                  <li>“Agreement” means these Terms and Conditions together with the Sales Quotation;</li>
                  <li>
                    “Additional Work” means any additional and/or rectification work that is required to complete the
                    Work, which was not included in the Sales Quotation or was not reasonably foreseeable on a visual
                    inspection of the Property by the Swyft Energy Consultant before we gave our Sales
                  </li>
                  <li>
                    “Boiler” means the mains gas central heating domestic boiler(s) to be installed as part of the Work
                    as set out in your Sales Quotation (if any); "us" or "we" means Swyft Energy (Ardrar Ltd. T/A Swyft
                    Energy);
                  </li>
                  <li>
                    “Swyft Energy Consultant” means a qualified and experienced evaluator engaged by Swyft Energy to
                    carry out an assessment on your home, and advise you on services you may wish to have carried out;
                  </li>
                  <li>
                    “B.S. 7593: 2006” means the British standard code of practice for treatment of water in domestic hot
                    water central heating systems, as laid down by the British Standards Institute, as amended or
                    replaced from time to time, and any reference in these terms and conditions to a specific provision
                    of B.S. 7593: 2006 shall be a reference to such provision as amended or replaced from time to time;
                  </li>
                  <li>“Central Heating Installation” shall have the meaning given to that term in clause 2;</li>
                  <li>
                    “Central Heating Parts” means any central heating parts to be installed as part of the Work as set
                    out in Your Sales Quotation, other than a Boiler;
                  </li>
                  <li>
                    “Central Heating System” means your existing central heating system at the Property (if any)
                    including: (a) the existing boiler; (b) the existing Controls, (including electrical temperature
                    controls); and (c) all existing pipes, pumps, radiators, valves, hot water cylinders and the
                    expansion vessel;
                  </li>
                  <li>
                    “Controls” means the programmer/time clock(s), room thermostat (if fitted), cylinder thermostat (if
                    fitted), zone valves (but excluding the fused spur switch) and smart heating;
                  </li>
                  <li>
                    “Declaration of Conformance Certificate” means a declaration of conformity issued by an RGII
                    accredited engineer in accordance with I.S. 813: 2002;
                  </li>
                  <li>
                    “Health and Safety Laws and Standards” means <br />
                    (a) the applicable requirements of health and safety legislation in Ireland including, but not
                    limited to, the Safety Health &amp; Welfare at Work Act 2005 and any regulations made thereunder
                    from time to time;
                    <br />
                    (b) The Building Control Acts 1990 and 2007 and any relevant Building Regulations made thereunder;
                    and
                    <br />
                    (c) all relevant safety standards applicable in Ireland, including, without limitation, I.S. 813:
                    2002 and B.S. 7593:2006;
                  </li>
                  <li>
                    "Installation Engineer" means a qualified and experienced engineer (RGII accredited) engaged by
                    Swyft Energy to carry out the Work;
                  </li>
                  <li>
                    "I.S. 813: 2002" means Irish Standard for the Domestic Gas Installation Standard as laid down by the
                    National Standards Authority of Ireland, as amended or replaced from time to time, and any reference
                    in these terms and conditions to a specific provision of IS shall be a reference to such provision
                    as amended or replaced from time to time;
                  </li>
                  <li>
                    “Notification of Hazard” means a notification issued to you in accordance with the requirements of
                    I.S. 813: 2002 to advise of a defect of a gas installation which might affect the safety of persons
                    or property;
                  </li>
                  <li>“Partial Installation” shall have the meaning given to that term in clause 2.</li>
                  <li>"Parties" means us and you;</li>
                  <li>
                    “Deposit” means that part of the Price you must pay before we will start the Work, as set out in
                    your Sales Quotation and/or email;
                  </li>
                  <li>
                    “Price” means the total price you must pay for the Work as set out in your Sales Quotation and/or
                    email;
                  </li>
                  <li>
                    “Property” means the domestic address shown on your Sales Quotation at which we shall carry out the
                    Work;
                  </li>
                  <li>“RGII” means the Register of Gas Installers of Ireland;</li>
                  <li>“Scope of Works” means the summary of the steps involved in the Work;</li>
                  <li>"Terms and Conditions" means these terms and conditions;</li>
                  <li>
                    “You or your” mean the person or people who have entered into this Contract with Swyft Energy and
                    includes a person who we reasonably believe is acting with your authority or knowledge;
                  </li>
                  <li>"VAT" means value added tax at the applicable rate from time to time; and</li>
                  <li>
                    “Work” means the work that we shall carry out at the Property, as detailed in your Sales Quotation,
                    being either a Central Heating Installation or a Partial Installation.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <span>The Service</span>
            <ol>
              <li>
                Where your agreement is for a Central Heating Installation, we will remove your Central Heating System
                and install your new central heating system including the installation of the Boiler, the Central
                Heating Parts and all other parts, material and labour required to complete the installation of your new
                central heating system (including, for the avoidance of doubt, all associated radiators, pipe work and
                fittings). Where your contract is for a Partial Installation, we will replace the relevant part(s) in
                your Central Heating System with the Boiler and/or Central Heating Parts (as the case may be) identified
                in the Sales Quotation signed by you (on sales quotation or via email) (including all other parts,
                material and labour required to install the Boiler and/or Central Heating Parts into your Central
                Heating System) (the “Service”).
              </li>
              <li>
                We will carry out the Work during normal working hours (8.00am to 6.00pm Monday to Friday excluding bank
                holidays and public holidays in Ireland), unless otherwise agreed between the Parties.
              </li>
              <li>
                We shall endeavour to provide accurate estimates for completion of the Work and will make reasonable
                efforts to complete the Work in accordance the estimates provided. We cannot, however, be held
                responsible for unexpected delays for example due to weather or other circumstances beyond our control
                and we will not be liable to you for any reasonable delay in the commencement or completion of the Work.
              </li>
              <li>
                When carrying out the Work, we will:
                <ol>
                  <li>(a) take reasonable care to avoid disrupting your Property;</li>
                  <li>(b) remove all waste material which results from the Work;</li>
                  <li>
                    (c) remove all disconnected and redundant parts of your Central Heating System which we replace; and
                  </li>
                  <li>(d) clean up after ourselves.</li>
                </ol>
              </li>
              <li>
                The Installation Engineer will, where applicable, carry out the Work in accordance with Health and
                Safety Laws and Standards and in accordance with the provisions of any relevant planning permission of
                which we are notified by you.
              </li>
              <li>It is your responsibility to allow us access to the Property to carry out the Work.</li>
              <span>PERMISSIONS</span>

              <li>
                This Agreement is subject to your confirmation that you are the owner of the Property and are not a
                tenant. In the absence of your advice to the contrary, we will assume that you are the owner of the
                Property. We shall not have any liability for any works which we carry out which have not been
                authorised by the owner of the Property and you agree to indemnify us for any losses howsoever arising
                that we incur from your failure to make full and proper disclosure as to the ownership of the Property.
              </li>
              <li>
                This Agreement is entered into and the Work is undertaken by Swyft Energy upon the condition that any
                required licences, authorities or permissions (including all requisite planning permissions) are first
                obtained by you and that unrestricted access to your Property will be available in order that the Work
                may be undertaken. We shall not have any liability for unauthorised works and you agree to indemnify us
                for any losses howsoever arising that we incur from your failure to obtain any required such licences,
                authorities or permissions.
              </li>
              <li>
                You shall inform us in advance of commencement of the Works of any conditions in any planning permission
                which are or may be relevant to the Works or the way in which such Works are or will be carried out. We
                reserve the right to notify you of any increase in the Price which may be required as a result of any
                conditions so notified to us, or in the event that we reasonably believe that we will not be able to
                comply with such conditions we may cancel this Agreement. You do not have to agree to any increase in
                the Price notified to you in accordance with this clause and if you do not so agree, either you or we
                may cancel this Agreement. In the absence of your advice to the contrary, we will assume that there are
                no relevant conditions in any planning permission of relevance to the Works as aforesaid. We shall not
                have any such liability for failure to comply with any condition in a planning permission which is not
                notified to us and you agree to indemnify us for any losses howsoever arising that we incur from your
                failure to comply with your obligations under this clause.
              </li>
              <li>
                The Boiler, Central Heating Parts and any other parts and materials will be your responsibility from the
                time of delivery to your property. Any loss, theft or damage to these materials will result in extra
                charges being incurred.
              </li>
              <li>
                If, before the Work is carried out, you wish to change the nature or the scope of Work to be carried
                out, we will advise you of any increase in the Price and provide you with a new Sales Quotation (which
                must be signed by you or confirmed via email) before we carry out the Work. Any variations required to
                be made to the Central Heating Installation, the Partial Installation or any Additional Work required to
                properly complete the Work and any additional costs associated therewith, shall be agreed with you prior
                to the commencement of the Work or as the case may be such Additional Work or variation of the Works.
              </li>
              <span>STEPS INVOLVED</span>
              <li>
                Prior to commencing the Work, the Installation Engineer will, where relevant:
                <ol>
                  <li>(a) visually inspect the relevant parts of the Property and the Central Heating System;</li>
                  <li>(b) test the integrity of the Central Heating System; and</li>
                  <li>
                    (c) carry out a full technical survey of the Property (including the Central Heating System) to
                    ascertain for the purpose of facilitating the Work:
                    <ol>
                      <li>the condition and soundness of your Central Heating System;</li>
                      <li>the condition and soundness of accessible gas pipe work and all flexible connections;</li>
                      <li>the adequacy of the fixed air supply;</li>
                      <li>the effectiveness of any flue or chimney;</li>
                      <li>the appropriateness of appliance locations;</li>
                      <li>the condition and soundness of the electrical system; and</li>
                      <li>the suitability of the gas, electricity and water supply to the Property.</li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                If the above inspections and system checks reveal that (a) any additional work is required, we shall
                inform you of same as soon as possible and confirm whether we are able to undertake such additional work
                and provide you with an estimate of the price and time required for completing the additional work; or
                (b) any gas safety hazards are identified, we shall inform you of same as soon as possible and issue you
                with a Notification of Hazard and (if possible) provide you with an estimate of the time required to
                remedy such gas safety hazards and any associated costs. We shall not be required to continue with any
                Work unless and until any increase in the Price has been agreed by you. We will issue you with a new
                Sales Quotation and you must sign this new Sales Quotation before we carry out the Work (which shall
                include the Additional Work). Please note that where the Installation Engineer issues a Notification of
                Hazard, we will not continue with any Work unless and until we have been provided with a Declaration of
                Conformance Certificate.
              </li>
              <li>
                A summary of the steps involved in the Work (the “Scope of Work”) is appended to the Sales Quotation.
              </li>
              <li>
                When carrying out the Work, we will (if required):
                <ol>
                  <li>install surface trunking for wiring;</li>
                  <li>
                    lift carpets or other floor coverings (this Work is at your risk and we will discuss and agree this
                    with you before doing so);
                  </li>
                  <li>
                    remove radiator coverings (this Work is at your risk and we will discuss and agree this with you
                    before doing so);
                  </li>
                  <li>
                    remove plaster where necessary and re-plaster to a smooth surface (if agreed and included in your
                    Sales Quotation);
                  </li>
                  <li>
                    remove and restore any existing boxing for pipework (if agreed and included in your Sales
                    Quotation);
                  </li>
                  <li>
                    fit grilles to supply air for combustion to standard flue appliances (if agreed and included in your
                    Sales Quotation);
                  </li>
                  <li>
                    remove and restore brickwork and roof-tiles (if agreed and included in your Sales Quotation). In
                    restoring brickwork or roof-tiles, we will either:
                    <ol>
                      <li>
                        use the nearest matching materials that we can obtain from a local builder’s merchant, and/or
                      </li>
                      <li>use bricks or tiles that you provide.</li>
                    </ol>
                  </li>
                </ol>
                <li>
                  Unless otherwise stated, electrical wiring, connections and material necessary for the carrying out of
                  the Work will be included in the Price. When carrying out the Work, we will not create channels for
                  wiring or pipework in solid walls or floors. The wiring to components will be run on the wall surface
                  unless otherwise specified and agreed in your Sales Quotation.
                </li>
                <li>
                  All new central heating pipe work will be run in tubing manufactured to the appropriate British
                  Standard or equivalent with suitable CE marked fittings.
                </li>
                <li>
                  Where solid fuel back boilers are present at your property they will be left drained and drilled only.
                  Removal of solid fuel back boilers will not be undertaken by Swyft Energy unless included for in
                  quote.
                </li>
                <li>
                  In the case of an existing oil fired Central Heating System, the oil tank will be disconnected by us
                  but we will not dispose of any oil contained in the oil tank and will not be responsible for the
                  removal of the oil tank unless included in the quote. This work should be undertaken by a specialist
                  contractor if not disposed by Swyft Energy.
                </li>
                <li>
                  We accept no responsibility for the suitability of any existing flue at your Property. If any existing
                  flue is to be used, you must arrange for it to be swept prior to commencement of the Installation or
                  Part Installation. If an existing flue is used and later proves to be unsatisfactory in operation then
                  you must arrange for a replacement flue system to be installed at your own cost. Flue liners will not
                  be installed in unswept chimneys, nor will fan assisted flue systems be connected to unswept chimneys.
                </li>
                <li>
                  While we will exercise all due care in carrying out the Work and will make good any unnecessary damage
                  caused by our negligence, you accept that the Work may cause damage to finishings both internally and
                  externally and that certain areas of your property may need redecoration following completion of the
                  Work. This contract does not include provision for the painting of radiators, the making good of
                  decorations, any additions to cold water secondary services, alteration to linen cupboard shelves,
                  renewal or repair of floor boards or old pipe runs, nor for the chasing or boxing in of pipes or wire.
                  All such redecoration or repair works will be your responsibility and are not included in the Price.
                </li>
                <li>
                  Swyft Energy take no responsibility for existing sludge or waste in your heating system. We will
                  drain, refill and add inhibitor to your heating system but we (Swyft Energy) cannot guarantee the
                  removal of all sludge and waste materials that existed prior to any works carried out by Swyft Energy.
                  In certain circumstances we may recommend a full chemical cleanse and flush of your heating system
                  prior to installation.
                </li>
                <li>
                  After the completion of the Work the Installation Engineer will:
                  <ol>
                    <li>
                      explain and demonstrate the functions of both time and temperature controls, for the economic use
                      of the central heating system;
                    </li>
                    <li>explain the user operating instructions for the Boiler and Controls;</li>
                    <li>issue you with a completed Declaration of Conformance;</li>
                    <li>issue you with a completed boiler passport (if a new Boiler has been fitted); and</li>
                    <li>
                      commission the Boiler and your central heating system in accordance with the particular
                      manufacturers’ instructions.
                    </li>
                  </ol>
                </li>
              </li>
            </ol>
          </li>
          <li>
            <span>Price</span>
            <ol>
              <li>
                The Sales Quotation is an offer by Swyft Energy to carry out the Work at the Price and is made on the
                basis that we will only carry out the Work. The Price (inclusive of VAT) set out in the Sales Quotation
                shall be valid for a period of 30 days from the date of the Sales Quotation unless we notify you, in
                writing, that we have withdrawn or amended it during that period. To accept the Price, a minimum deposit
                of between €99 and €1000 must be paid, or finance approved through our finance partners.
              </li>
              <li>
                We may run a credit check against you in advance of completion of the Work. The purpose of this credit
                check is to determine the appropriate payment terms for the Work. Payment for the full amount of the
                Sales Quotation is required at least 2 days prior to installation.
              </li>
              <li>
                We will ask for your payment details and preferred payment method in advance of providing you with a
                completed Sales Quotation and will also advise you of the relevant amount. If you do not pay us any sum
                due under this Agreement when due, we may charge you a late payment fee equal to 10% of any amount
                outstanding.
              </li>
            </ol>
          </li>
          <li>
            <span>Supplemental Costs</span>
            <ol>
              <li>The Price does not include the cost of removing any dangerous waste material, such as asbestos.</li>
              <li>
                The cutting away and making good of the fireplace aperture is not included in the Price where a
                fire/back boiler unit is specified in the Sales Quotation. The removal of flue liners is also not
                included. Swyft Energy does not accept responsibility for removal or reinstatement of any decorations or
                decorative features in the vicinity of the fireplace aperture.
              </li>
              <li>
                You have no obligation to agree to any increase in the Price for carrying out the Additional Work, and
                if you do not agree to any Additional Work identified by us or if a Notification of Hazard is issued,
                either we or you may cancel the Service. In these circumstances, we shall remove any Boiler or central
                heating parts or Controls that we have installed, and shall restore your Property and Central Heating
                System (if applicable) to the state they were in before we began Work. We shall be entitled to charge
                you a reasonable amount to cover our costs in carrying out the Work up to the date on which the
                Replacement Service is cancelled and also in relation to restoring your Property and Central Heating
                System. We may deduct these costs from your Deposit and if the costs exceed your Deposit, we may recover
                the excess from you.
              </li>
            </ol>
          </li>
          <li>
            <span>Cancellation / Termination</span>
            <ol>
              <li>
                Subject to the other provisions of this clause 5, you may cancel the Service by contacting us on
                021-7011238 or emailing us at info@swyftenergy.ie.
              </li>
              <li>
                Once you have accepted the Sales Quotation, neither party may cancel the Service unless:
                <ol>
                  <li>these Terms and Conditions allow it;</li>
                  <li>
                    Swyft Energy is in breach of any of the Agreement, in which case you shall be entitled to cancel the
                    Service;
                  </li>
                  <li>
                    you are in breach of any of the Agreement, in which case we shall be entitled to cancel the Service;
                  </li>
                  <li>
                    you have not paid the Deposit (if applicable) or, in our reasonable opinion, you have no reasonable
                    prospect of paying the in; or
                  </li>
                  <li>
                    there is a health and safety issue that means it is inappropriate to fulfil the Service in which
                    case, we may cancel the Service.
                  </li>
                </ol>
              </li>
              <li>If you cancel the Service, our liability to you is as set out in clause 11 hereof.</li>
              <li>
                Without affecting any other right or remedy we may have, if we cancel the Service in accordance with
                this clause 5, we shall be entitled to charge you the reasonable costs we have incurred in carrying out
                the Service before the date of cancellation. We may deduct these costs from your Deposit, and if the
                costs exceed your Deposit, we may recover the excess from you.
              </li>
              <li>
                You may cancel a booking for Service up to 5 working days before the Work is due to be carried out. If
                you exercise this right of cancellation, please note that you will be liable for any costs associated
                with any boiler or parts sourced by us in preparation for the performance of the Work before we received
                notice of your cancellation (and which cannot be returned to the original supplier or otherwise resold
                within a reasonable period). You hereby agree that we may deduct these costs from your Deposit and if
                the costs exceed your Deposit, we may recover the excess from you. Repeated cancellations of a booking
                or lack of access to your Property may, at our discretion, result in refusal to carry out any work
                associated with your booking. Upon cancellation by you, Swyft Energy will have no further duties with
                respect to your booking.
              </li>
              <li>
                Swyft Energy shall be entitled to cancel your booking for the Service, at any time, without giving a
                reason and we will have no further duties with respect to your booking.
              </li>
            </ol>
          </li>
          <li>
            <span>Refusal to provide the Service</span>
            <ol>
              <li>
                Swyft Energy shall be entitled to refuse to provide the Service to you, at any time, without giving a
                reason.
              </li>
              <li>
                We will not be obliged to carry out the Work unless:
                <ol>
                  <li>you have accepted the duly completed Sales Quotation;</li>
                  <li>
                    you have confirmed that you are the owner of the Property or the owner of the Property has confirmed
                    to us, in such form as we may require, that he/she authorises the Works;
                  </li>
                  <li>the scope of Additional Work (if any) has been agreed between you and Swyft Energy;</li>
                  <li>
                    a satisfactory survey of the Property has been carried out by us in accordance with clause 2.12;
                  </li>
                  <li>we are satisfied with your credit check results if applicable; and</li>
                  <li>you have paid the Deposit if applicable.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <span>Replacement Parts</span>
            <ol>
              <li>
                The Installation Engineer may, while carrying out the Service, identify parts in your boiler requiring
                replacement.
              </li>
              <li>
                The Installation Engineer will advise you of the cost of replacing these parts and, subject to your
                consent, will supply and fit suitable replacement parts.
              </li>
              <li>
                If during the Service, the Installation Engineer is required to leave your Property to obtain any
                replacement parts, Swyft Energy shall require payment for the Service before the Installation Engineer
                leaves your Property.
              </li>
              <li>
                Payment for replacement parts will be required at the time of installation of the replacement parts. In
                some circumstances, and depending on the cost or availability of a replacement part, Swyft Energy
                reserves the right to request payment in advance of installation of the replacement parts. Ownership of
                any replacement parts will only pass to you upon payment.
              </li>
              <li>
                Replacement parts may not be identical to the parts in your boiler being replaced and may be from a
                different manufacturer.
              </li>
              <li>
                Swyftenergy will not be responsible for any delay in the provision of replacement parts by suppliers or
                manufacturers.
              </li>
              <li>
                Any parts which are removed from your boiler by the Installation Engineer will, unless you specify
                otherwise, be taken away for correct disposal by the Installation
              </li>
            </ol>
          </li>
          <li>
            <span>Workmanship Guarantee</span>
            <ol>
              <li>
                A workmanship guarantee of 1 year will apply to any replacement parts installed/replaced by the
                Installation Engineer (from date of installation of the replacement part).
              </li>
              <li>The workmanship guarantee covers labour only on parts installed/replaced by our engineers.</li>
              <li>
                The workmanship guarantee does not cover existing pipework or parts of your heating system that have not
                been installed/replaced by Swyft Energy.
              </li>
              <li>
                If you have any problems with the work undertaken by the Installation Engineer and notify us of same
                within this period, there will be no call out charge payable by you if the Engineer is required to call
                back to you.
              </li>
              <li>
                If the Swyft Energy team feel the issue is not related to works undertaken by the engineer, a €100 call
                out charge may be applied at the time of booking the engineer to return to the job. If the engineer
                identifies the issue is relating to works undertaken by Swyft Energy, the €100 call out charge will be
                fully refunded.
              </li>
              <li>
                If the Engineer identifies a problem that is not related to the works he/she carried out, the
                Installation Engineer will advise you accordingly and, subject to your consent, will attempt to rectify
                the matter.
              </li>
              <li>
                You will be charged for the time it takes for the Installation Engineer to rectify the matter and for
                the cost of any replacement parts required. Time will be charged in 20 minute units after the first hour
                as per our rate. You will not incur any charge without your prior consent.
              </li>
              <li>
                If you experience any problems with the work after the guarantee period, a €100 call out charge will be
                applied at the time of booking an Engineer to visit your property. Any additional time after the first
                hour will be charged in 20 minutes units as per our rate.
              </li>
            </ol>
          </li>
          <li>
            <span>Conditions of Property and Appliance</span>
            <ol>
              <li>
                This Agreement is subject to a suitable gas, electricity and water supply being available to your
                Property. The cost of providing such a supply is not included in the Sales Quotation unless shown as a
                separate item.
              </li>
              <li>
                You are responsible for making sure that conditions at your Property are suitable for us to do the Work
                and the necessary facilities, services and supplies are already installed and working at your Property.
              </li>
              <li>
                If we consider that the conditions at your Property are not suitable for us to do the Work (which may
                include the presence of asbestos at your Property) we will tell you what you must do before we can
                perform the Work.
              </li>
              <li>
                Before we start Work, you must clear any furniture or fittings from any rooms or roof space that we need
                to enter to do the Work. The Swyft Energy Consultant will agree with you how much clearing you will need
                to do. If you do not clear the furniture and fittings as agreed, we may charge you a reasonable amount
                to cover our costs for any delay. It is not envisaged that our Installation Engineers will be
                responsible for clearing any furniture or fittings, however if, due to your personal circumstances, you
                would like us to carry out any such clearing work, we may, at our discretion, do so but only on the
                basis that we are not liable for any damage caused as a result (unless we have been negligent).
              </li>
              <li>
                If you do not comply with your obligations under this clause 9, we will have the right to cancel the
                Replacement Service in accordance with clause 5.
              </li>
              <li>
                Any work carried out by Swyft Energy to an appliance does not imply that the appliance is adequately
                manufactured or installed or that it satisfies applicable standards or regulations. In no circumstances,
                does Swyft Energy accept responsibility in relation to inadequacies with the original design or
                installation of an appliance or the hot water system (e.g. heating up time, incorrect radiator sizes,
                faulty pipe work or lack of water circulating in any part of the Central Heating System, or damage
                resulting from disturbance of existing supplies, tanks or cylinder). Moreover, Swyft Energy does not
                warrant the fitness for purpose or condition of an appliance.
              </li>
              <li>
                During the course of the Works, we shall endeavour to inform you of any deficiency or inadequacy
                attributable to or in the original design or installation of the Central Heating System or hot water
                system. We will also provide you with a quotation for rectifying such deficiencies or inadequacies.
              </li>
              <li>
                We do not accept responsibility or liability for the quality or condition of any existing equipment or
                appliance in the Property (including, without limitation, the Central Heating System and hot water
                system or any part thereof).
              </li>
              <li>
                We may identify and inform you that new parts need to be connected to your existing Central Heating
                System and you may instruct us to connect these new parts. Please note, however, that we will not accept
                responsibility or liability for the cost of repairing or replacing these new parts unless we have been
                negligent in connecting these new parts.
              </li>
              <li>
                We accept no responsibility or liability where your Central Heating System fails to work properly and
                such failure is attributable to inadequacies in your electricity or water supply or varying water
                pressures.
              </li>
              <li>
                The quote is subject to that the premises conforms with all current ETCI regulations ie.
                <ol>
                  <li>Main electrical installation is correctly neutralized.</li>
                  <li>Main supply cable is of 10sq/16sq.</li>
                  <li>Earth electrode is in place.</li>
                  <li>10sq earth cable is present at gas pipe.</li>
                  <li>All relevant pipe work is earthed</li>
                  <li>Supply to boiler is RCD(trip switch) protected complete with 3 amp fuse.</li>
                  <li>Loop impedance readings and RCD tripping time is within given guidelines.</li>
                </ol>
                If any of the above electrical requirements are not present the responsibility and cost of the
                associated works will be that off owner of premises.
              </li>
            </ol>
          </li>
          <li>
            <span>Use of Subcontractors</span>
            <ol>
              <li>
                Swyftenergy shall not be liable for any work carried out on your boiler, appliance or central heating
                system by a third party and we reserve the right to immediately terminate any warranty provided by us in
                relation to your boiler, appliance or Central Heating System where work is carried out by a third party
                without our prior written consent.
              </li>
            </ol>
          </li>
          <li>
            <span>Limitation of Liability</span>
            <ol>
              <li>
                Swyft Energy shall not be liable for any work carried out on your boiler, appliance or central heating
                system by a third party and we reserve the right to immediately terminate any warranty provided by us in
                relation to your boiler, appliance or Central Heating System where work is carried out by a third party
                without our prior written consent.
              </li>
              <li>
                You hereby agree to indemnify us and keep us indemnified in respect of any actions, claims or
                proceedings brought against us together with all loss, damage, costs and expenses which we may incur as
                a consequence of any work carried out on your boiler, appliance or Central Heating System by any party
                other than Swyft Energy without our prior written consent.
              </li>
              <li>
                In no circumstances shall we liable for any indirect, special or consequential loss you suffer arising
                out of or in connection with the provision or non-provision of any goods or services as a result of the
                Service.
              </li>
              <li>
                We have no obligation, duty or liability to you, in contract or tort, for breach of statutory duty or
                otherwise beyond that of a duty to exercise reasonable skill and care.
              </li>
              <li>
                Nothing in the Agreement purports to disclaim liability for fraud or for death or personal injury to you
                which is attributed to Swyft Energy. In addition, nothing in the Agreement purports to contract out of
                the implied undertakings as to quality of service in Section 39 of the Sale of Goods and Supply of
                Services Act 1980.
              </li>
              <li>
                When carrying out the Work, we will not accept responsibility for damage to radiator covers, carpets or
                other floor coverings caused by lifting or refitting, unless we have been negligent in doing so.
              </li>
            </ol>
          </li>
          <li>
            <span>Force Majeure</span>
            <ol>
              <li>
                Swyft Energy shall not be liable if any or all of our obligations under the Agreement cannot be carried
                out or fulfilled for reasons beyond our control including, but not limited to, Acts of God, industrial
                dispute, explosion, flood, lightning, storms, fire or accident, war or threat of war, sabotage,
                insurrection, civil disturbance or disorder, acts, restrictions, regulations, by-laws, prohibitions or
                measures of any kind on the part of any governmental authority, import or export regulations or
                embargoes, defaults of suppliers or sub-contractors or any act or omission of any nature whatsoever on
                the part of the Customer or its agents.
              </li>
            </ol>
          </li>
          <li>
            <span>Use of Personal Information</span>
            <ol>
              <li>Swyft Energy will comply with our obligations under any applicable data protection legislation.</li>
              <li>
                In order that Swyft Energy may perform its obligations under these Terms and Conditions and provide you
                with the service, Swyft Energy will collect and use information relating to you. Swyft Energy may keep
                this information for a reasonable period after it has ceased to provide you with the service but will
                not keep it for any longer than is necessary and/or as required by law.
              </li>
              <li>
                Information which you provide or we hold may be used by us, our employees, subcontractors and/or our
                agents;
                <ol>
                  <li>for the purposes of attending your property;</li>
                  <li>to help identify you when you call;</li>
                  <li>
                    for contacting you in writing and/or by phone and/or by text message and/or by e-mail with
                    information about other services and products offered by us and/or our carefully selected partners
                    where you have consented;
                  </li>
                  <li>to detect and prevent crime, fraud and loss;</li>
                  <li>for health and safety and risk assessment;</li>
                  <li>for administering accounts; and</li>
                  <li>for credit checking purposes.</li>
                </ol>
              </li>
              <li>
                We may carry out credit and fraud prevention checks with licensed credit reference and fraud prevention
                agencies and they will retain a copy of the search. Information from your application and payment
                details of your account may be recorded by these agencies and may be shared with other organisations to
                help make credit and insurance decisions about you and members of your household and for debt collection
                and fraud prevention purposes.
              </li>
              <li>
                Swyft Energy may disclose your information to other agents who act on behalf of Swyft Energy in
                connection with the activities referred to above, including to any agent or third party service provider
                who Swyft Energy may engage to assist us in the performance of the service. Such agents or third parties
                are only permitted to use your data as instructed by Swyft Energy. They are also required to keep your
                data safe and secure.
              </li>
              <li>
                In the event that you speak to any employees of Swyft Energy (or agents acting on its behalf) by
                telephone, your telephone conversations may be recorded for quality control purposes. Swyft Energy will
                treat the recorded conversation confidential and will only use it for staff training/quality control
                purposes, confirming details of your conversations with Swyft Energy or any other purposes mentioned in
                these Terms and Conditions.
              </li>
              <li>
                In order to protect your privacy, you may also be asked to provide suitable proof of identification. If
                any of your details are incorrect please let us know and we will amend them.
              </li>
              <li>
                You have the right to ask for a copy of your personal data (Swyft Energy is entitled to charge a nominal
                administration fee for this). If you wish to avail of this right, you should submit a written request
                to: Swyft Energy, Rubicon Centre, Bishopstown, Cork
              </li>
            </ol>
          </li>
          <li>
            <span>Marketing</span>
            <ol>
              <li>
                Swyft Energy (and/or our agents) may wish to contact you from time to time by text message, email, post,
                telephone or in person with information in relation to a product or a service which you have requested
                or received from us. We may also contact you with information about new or additional products or
                services.
              </li>
              <li>
                If you do not wish to be contacted with information about our products and services, please exercise
                your right of opt-out by emailing us at info@swyftenergy.ie or writing to us at: Swyft Energy, Rubicon
                Centre, Bishopstown, Cork.
              </li>
            </ol>
          </li>
          <li>
            <span>Complaints Procedure</span>
            <ol>
              <li>
                You can register your complaint with us in any of the following ways:
                <ol>
                  <li>by calling our customer contact team on 021-7011238;</li>
                  <li>by email to info@swyftenergy.ie;</li>
                  <li>through our website at www.swyftenergy.ie; or</li>
                  <li>in by letter to: Swyft Energy, Rubicon Centre, Bishopstown, Cork.</li>
                </ol>
              </li>
            </ol>
          </li>
          <li>
            <span>General</span>
            <ol>
              <li>
                These Terms and Conditions apply to the Service provided by Ardrar Limited trading as Swyft Energy a
                limited liability company with registered number 591657and with registered address at Rubicon Centre,
                Bishopstown, Cork.
              </li>
              <li>
                Notices: Any notice or account sent by ordinary post relating to the Agreement shall be deemed to have
                been received on the day that is the 2nd postal day after the day of such posting. Any notice sent by
                the Customer by electronic mail shall be deemed to have been received upon confirmation of receipt from
                Swyft Energy by electronic mail or by post. Any notice required or permitted to be given by the Customer
                shall be in writing addressed to Swyft Energy, Rubicon Centre, Bishopstown, Cork or such other address
                or electronic mail address as may be provided to the Customer by Swyft Energy from time to time.
              </li>
              <li>
                Authority: By entering into this Agreement with Swyft Energy, you shall be deemed to have obtained all
                such licences and consents as are required to allow Swyft Energy to lawfully undertake the Service or
                other works. If you have failed to obtain all necessary licences and consents required you will
                indemnify Swyft Energy for all loss or damage suffered and shall remain responsible for all work done
                and materials supplied on a quantum merit basis.
              </li>
              <li>
                Asbestos: Unless otherwise stated in correspondence with Swyft Energy, the Service does not allow for
                working in the vicinity of asbestos. If during the provision by Swyft Energy of the Service asbestos is
                encountered Swyft Energy reserves the right to withdraw its staff immediately until the premises is made
                safe. The presence of asbestos on the premises will be reported to you by Swyft Energy for your
                instructions regarding safe disposal. Swyft Energy will not be responsible for the cost involved in
                disposing of any asbestos found.
              </li>
              <li>
                Amendments: We reserve the right to change these Terms and Conditions at any time. We will publish
                details of any changes on the Swyft Energy website www.swyftenergy.ie as soon as possible prior to the
                changes being introduced.
              </li>
              <li>
                Assignment: The Agreement is personal to you and therefore may not be assigned or transferred by you to
                any other person without our prior written consent. For business reasons, we have the right to assign
                the Agreement to any company or person.
              </li>
              <li>
                No waiver: No forbearance, indulgence or relaxation on the part of Swyft Energy shown or granted to the
                Customer shall in any way affect, diminish, restrict or prejudice the rights or powers of Swyft Energy
                or operate as or be deemed to be a waiver of any breach of the Agreement.
              </li>
              <li>
                Severance: If any provision of the Agreement is held by any competent authority to be invalid or
                unenforceable in whole or in part, the validity of the other provisions and the remainder of the
                provision in question shall not be affected.
              </li>
              <li>
                Governing Law: This Agreement shall be governed by and construed in accordance with the law of the
                Republic of Ireland. The parties irrevocably submit to the exclusive jurisdiction of the courts of
                Republic of Ireland.
              </li>
              <li>
                Swyft Energy Re-Organisation: Notwithstanding anything to the contrary in the Agreement, if Swyft Energy
                should reorganise the business and/or legal structure of Swyft Energy (whether by dividing its business
                between two or more corporate bodies or otherwise), the obligations of Swyft Energy may be divided
                between such bodies and you shall thereafter deal with such bodies as if the parts of the Agreement
                relevant to the business of such bodies formed a contract between you and such corporate bodies.
              </li>
              <li>
                Entire Agreement: This Agreements constitutes the complete agreement between you and us in relation to
                the Boiler Service and supersedes all prior understandings, agreements, representations or
                communications whether written or oral between you and us relating to the subject matter hereof, but no
                term purports to exclude liability for fraud.
              </li>
            </ol>
          </li>
          <li>
            <span>Promotions</span>
            <br />
            <Typography variant="body2">
              These Promotions Terms and Conditions are supplemented by our Terms and Conditions of Website Use and our
              Privacy Policy and they are binding upon you.
            </Typography>

            <Typography variant="body2">
              These Promotions Terms and Conditions refer to prize draws, gift offers and promotions brought to you by
              Ardrar Limited trading as Swyft Energy, whose registered office is at The Rubicon Center, Bishopstown,
              Cork ("Swyft Energy", "we", "us", "our"). These Promotions Terms and Conditions should be read alongside,
              and are in addition to, any specific terms that we have included in any promotion or message about that
              prize draw, for example by email, in any of our marketing material or online ("Promotional Material"). If
              there is any inconsistency between these Promotions Terms and Conditions and any applicable Promotional
              Material, such Promotional Material will prevail to the extent of such inconsistency.
            </Typography>
            <ol>
              <li>
                General
                <ol>
                  <li>
                    Swyft Energy may from time to time run promotions and offers on swyftenergy.ie (the “Website”),
                    through the Swyft Energy social media pages and/or via email/SMS.
                  </li>
                  <li>
                    Promotions may only be used in respect of the orders specified by the Promotional Material relating
                    to such promotion. Only one promotion can be used per order. A promotion may not be used in
                    combination with other promotions or used to collect reward points except where specified.
                  </li>
                  <li>
                    From time to time certain Swyft Energy products may be excluded from current promotions and any such
                    exclusion will be notified to you through a notice on the Website and/or the Swyft Energy social
                    media pages and/or via email/SMS.
                  </li>
                  <li>
                    Excluded products will not count towards any qualifying conditions for offers and will not benefit
                    from any promotional discount.
                  </li>
                  <li>
                    All promotions and offers are subject to availability. We reserve the right to end a promotion at
                    any time.
                  </li>
                  <li>
                    We shall not be liable for any financial loss arising out of the refusal, cancellation or withdrawal
                    of any promotion or any failure or inability of a customer to take advantage of a promotion for any
                    reason.
                  </li>
                </ol>
              </li>

              <li>
                Free Gifts
                <ol>
                  <li>
                    From time to time we may offer free gift promotions on the Website, through our social media pages,
                    online advertising or via email/SMS. In order to claim a free gift, you must quote the relevant gift
                    code when placing your order. Free gift promotions can be very popular and while we do our best to
                    ensure that everyone receives the free gift, there can be instances where the gift contents may be
                    substituted and/or when we run out of stock and therefore are unable to fulfil the free gift offer.
                  </li>
                  <li>
                    Where a free gift is offered subject to a minimum spend requirement, VAT and supplementary charges
                    (such as delivery, gift wrap or postage & packing) may still be payable and shall not count towards
                    a minimum spending requirement.
                  </li>
                  <li>
                    Gifts are limited to one per customer unless otherwise stated. Only one gift can be claimed with
                    each order and cannot be used in conjunction with any other special offers. We reserve the right to
                    substitute with a product of equal or greater value in the event that stock of a gift item becomes
                    unavailable.
                  </li>
                </ol>
              </li>

              <li>
                Vouchers/Promotional Codes
                <ol>
                  <li>
                    From time to time we may send you a promotional code by email or SMS. Such codes may be used on the
                    Website to qualify for certain promotions or discounts. Codes are subject to these Promotions Terms
                    and Conditions and any other terms and conditions notified to you at the time of issuance of the
                    code.
                  </li>
                  <li>A code is redeemed by entering its code at the appropriate point in the purchase process.</li>
                  <li>We reserve the right to withdraw or cancel a code for any reason at any time.</li>
                  <li>
                    Swyft Energy reserves the right to decline to accept orders where, in its reasonable opinion, a code
                    is invalid for the order being placed or is the subject of fraudulent activity.
                  </li>
                  <li>Codes cannot be exchanged for cash or used to purchase gift vouchers.</li>
                  <li>
                    Unless expressly stated at the time of issue, each code will be valid for use by the recipient of
                    the code and by such recipient once only and may not be used in conjunction with any other
                    promotion.
                  </li>
                  <li>
                    From time to time certain products may be excluded from code offers and any such exclusion will be
                    notified to you at the time the code is issued to you or through the Website, the Swyft Energy
                    social media pages and/or via email/SMS.
                  </li>
                  <li>
                    No code may be copied, reproduced, distributed, or published directly or indirectly in any form or
                    by any other means for use by an entity other than the original recipient without our prior written
                    permission.
                  </li>
                  <li>
                    Codes distributed or circulated without the written approval of Swyft Energy, for example on an
                    Internet message board or through social media, are not valid for use and may be refused or
                    cancelled.
                  </li>
                  <li>
                    When you use a code you warrant to us that you are the duly authorised recipient of the code and
                    that you are using it in good faith.
                  </li>
                  <li>
                    If you redeem, attempt to redeem or encourage the redemption of codes to obtain discounts to which
                    you or a third party are not entitled you may be committing a civil or criminal offence.
                  </li>
                  <li>
                    If we reasonably believe that any code is being used in contravention of these Promotions Terms and
                    Conditions or any other applicable terms and conditions we may reject or cancel such code and you
                    agree that you will have no claim against us in respect of any rejection or cancellation. We reserve
                    the right to take any further action we deem appropriate in such instances.
                  </li>
                  <li>
                    If, for any reason, we refuse a code submitted as part of an order, we will inform you before the
                    order is dispatched to advise of the correct cost of the order and give you the opportunity to
                    cancel the order.
                  </li>
                </ol>
              </li>

              <li>
                Discounts
                <ol>
                  <li>
                    Where an online offer states that a discount is given on a purchase up to a stated percentage, the
                    discount given will only be applicable to qualifying products and the percentage of discount given
                    may vary between qualifying products.
                  </li>
                  <li>
                    Supplementary charges such as delivery or postage & packing shall not be discounted unless
                    specifically stated in the promotion description.
                  </li>
                  <li>
                    Refunds for goods purchased under a promotional offer will be based on the terms of the promotional
                    price. Your statutory rights are not affected.
                  </li>
                </ol>
              </li>
              <li>
                Competitions
                <ol>
                  <li>
                    From time to time we run free to enter prize competitions on the Website, through social media or
                    via SMS/email (“Competitions”).
                  </li>
                  <li>
                    Competitions are open to residents of the Republic of Ireland who access the Website from the
                    Republic of Ireland and all participants must be aged 18 or over (“Participants”). All Participants
                    agree to be bound by these Promotions Terms and Conditions. Swyft Energy reserves the right to
                    cancel, terminate, modify or suspend a Competition and/or vary Competition rules at any time without
                    prior notice. Swyft Energy reserves the right to disqualify any Participant for any reason
                    whatsoever in its sole discretion.
                  </li>
                  <li>
                    Employees of Swyft Energy or affiliated entities and their immediate family members are not eligible
                    to enter prize competitions.
                  </li>
                  <li>
                    All Competitions will state the opening date and time and the closing date and time and the
                    competition will only be open during such term. Swyft Energy does not accept any responsibility
                    whatsoever for any technical failure or malfunction or any other problem in any network, system,
                    server, provider, or otherwise which may result in entries being lost or not properly registered or
                    recorded and contestants hereby waive any claim whatsoever for any losses, costs, damages and
                    expenses arising from any such problems.
                  </li>
                  <li>
                    In order to enter into any such Competition, Participants will be required to submit their name,
                    telephone number, address and e-mail address. This information will be used to notify the winner and
                    deliver any prize. The Participants’ personal information will be processed in accordance with our
                    Privacy Policy. Full details of out Privacy Policy can be found at
                    https://www.swyftenergy.ie/privacy-policy.
                  </li>
                  <li>
                    In order to be eligible to win the relevant Competition, each Participant shall first need to
                    qualify for the Competition by passing a skill, judgement or knowledge test in accordance with the
                    rules of the specific Competition. Where this is required and where an entrant fails to take part as
                    required or takes part but fails such test of skill, judgment or knowledge which is required to win
                    the Prize, that contestant will be deemed to have forfeited their opportunity to win the Prize and
                    will be disqualified from the Competition. The winner of the Competition will be chosen at random
                    from those Participants who have successfully passed the skill, judgement or knowledge test (the
                    “Winner”). All decisions taken by Swyft Energy in relation to a Competition, whether in relation to
                    validity of an entry, the Winner or otherwise are final and no correspondence will be entered into.
                  </li>
                  <li>
                    Each Winner will receive the prize detailed in the Promotional Material for the relevant Competition
                    (the “Prize”). The Prize is non -transferable and non-refundable. There is no cash or other
                    alternative in respect of a Prize. We reserve the right to change any aspect of the Prize, including
                    (but not limited to) the substitution of a Prize of like value in the event that the awarded Prize
                    is unavailable for any reason whatsoever. Unless otherwise stated, all taxes, insurance, fees and
                    surcharges on any prize are the sole responsibility of the Winner.
                  </li>
                  <li>
                    The winner of each Competition will be notified by email, SMS or telephone as soon as reasonably
                    practicable after the Competition has ended. Prizes will either be emailed to the Participant’s
                    email address where the relevant Prize is a non-physical digital item (such as a code) or sent to
                    the Participant’s registered address in circumstances where the relevant Prize is a physical item.
                  </li>
                  <li>
                    Winners of the competitions may be displayed on the Website or on our social media pages in the
                    format title surname area e.g. Mr Jones from Dublin. You hereby consent to this use. Winners must,
                    at Swyft Energy’s request, participate in all reasonable promotional activity (such as publicity and
                    photography) surrounding the winning of the prize, free of charge, and they consent to Swyft Energy
                    using their name and image in promotional material both on and offline.
                  </li>
                  <li>
                    Competitions may be subject to additional rules. If so, these additional rules will be listed on the
                    relevant competition entry page on the Website, the Swyft Energy social media pages and/or via
                    email/SMS and form part of these Promotions Terms and Conditions.
                  </li>
                  <li>
                    By registration on entry to the Competition, Participants indicate that they have accepted these
                    Promotions Terms and Conditions.
                  </li>
                  <li>
                    We accept no responsibility or liability for loss to any person or property relating to the award of
                    any Prize save for death or personal injury caused by our negligence for which our liability is
                    unlimited.
                  </li>
                  <li>
                    We reserve the right to cancel the award of the Prize at our sole discretion without prior notice if
                    the Prize cannot be delivered to the postal address indicated by the Winner and is returned to us.
                  </li>
                  <li>
                    Should we cancel a Competition or the awarding of a Prize to a Winner for any reason in our sole
                    discretion no form of compensation will be offered to the Winner.
                  </li>
                  <li>
                    We will not be liable for any malfunction or event beyond our reasonable control which prevents
                    entry to the competition or fulfilment of the prize.
                  </li>
                  <li>
                    We will not be liable for any loss or damage to property whether material, financial or other which
                    may occur when taking part in a Competition.
                  </li>
                  <li>
                    These Terms shall be governed by the laws of Ireland and the courts of Ireland shall have
                    jurisdiction to hear any dispute in relation to them.
                  </li>
                </ol>
              </li>
            </ol>
          </li>
        </ol>
      </Container>
    </div>
  );
};
